import React from "react";
import "./Mission.css";

function Mission() {
  return (
    <div className="mission-container">
      <div className="sec-content-container">
        <div className="sec-title">Our Mission</div>
        <div className="mission-content">
          <div className="text-l">
            At RisoApp, our mission is to empower individuals by providing personalized guidance that nurtures both educational success and mental well-being. We combine advanced AI technology with compassionate human counseling to support users in making confident decisions,
          </div>
          <div className="text-r">
            overcoming challenges, and achieving their fullest potential. <br /><br />
            
            We are committed to creating a supportive environment where every student, job seeker, and professional can grow academically, emotionally, and professionally.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mission;
